module.exports = __webpack_public_path__ + "img/stylus-pen.67bf3f97.svg";